import { RETURN_VALUE_ERROR_CODES } from '../constants';
import type { EthersError, ReturnValue } from '../types';

export const getTenderlyGasLimitError = (error: EthersError): ReturnValue => {
	// check tenderly error and fields if they don't exist then strigify
	if (error && error.name && error.message) {
		return {
			title: error.name,
			description: error.message
		};
	}
	return {
		title: RETURN_VALUE_ERROR_CODES.FAILED_TO_PARSE_ERROR,
		description: JSON.stringify(error, Object.getOwnPropertyNames(error))
	};
};
